import React from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { getOtpRoute } from 'src/utils/adminOtp';
import useAuth from '../hooks/useAuth';

const GuestGuard = ({ children }) => {
  const {
    isAuthenticated, otpPending, otpPhase, user
  } = useAuth();

  if (isAuthenticated) {
    if (user.role === 'EXAM_CENTER') {
      return <Redirect to="/app/exam-center" />;
    }
    return <Redirect to="/app/dashboard" />;
  }

  if (otpPending) {
    return <Redirect to={getOtpRoute(otpPhase)} />;
  }

  return <>{children}</>;
};

GuestGuard.propTypes = {
  children: PropTypes.node
};

export default GuestGuard;
